import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { NetworkType } from './types';

export const networkTypeApi = createApi({
  reducerPath: 'networkTypeApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getNetworkTypes: builder.query<NetworkType[], void>({
      query: () => ({
        url: '/network-types',
      }),
    }),
  }),
});

export const { useGetNetworkTypesQuery } = networkTypeApi;
